import React from 'react';

const Member = ({ sectionData }) => {
  if (!sectionData || sectionData.length === 0) return null;

  // Assuming the first item in section_3 is the Member table data
  const memberData = sectionData[0]; 

  if (!memberData?.table) return null;

  const { columns, rows } = memberData.table;

  return (
    <section className="mb-5">
      <div className="container"> 
        <div className="sec-title text-center">
          <h2>{memberData.main_heading || "Members"}</h2>
        </div>
         
        <div className="table-responsive d-flex justify-content-center">
          <table className="table member-table">
            <thead>
              <tr>
                {columns.map((col, index) => (
                  <th 
                    key={index} 
                    className={index === 0 ? "text-center" : ""}
                    style={index === 0 ? { width: '60px' } : {}}
                  >
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {row.map((cell, cellIndex) => (
                    <td 
                      key={cellIndex} 
                      className={cellIndex === 0 ? "text-center" : ""}
                      // Check if cell contains HTML like <br/> and render safely, else render text
                    >
                      <div dangerouslySetInnerHTML={{ __html: cell }} />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default Member;